import { uploadAsset } from './upload-assets'

type UploadEventScheduleItemAssetsParams = {
  coverFile?: File
  bannerFile?: File
  eventSlug: string
  itemTitle: string
}

export async function uploadEventScheduleItemAssets({
  coverFile,
  bannerFile,
  eventSlug,
  itemTitle,
}: UploadEventScheduleItemAssetsParams) {
  const assetTitle = `${eventSlug}-${itemTitle}`

  const [coverFiles, bannerFiles] = await Promise.all([
    coverFile
      ? uploadAsset({
          file: coverFile,
          folder: 'events',
          title: `${assetTitle}-cover`,
          visibility: 'public',
        })
      : Promise.resolve([]),
    bannerFile
      ? uploadAsset({
          file: bannerFile,
          folder: 'events',
          title: `${assetTitle}-banner`,
          visibility: 'public',
        })
      : Promise.resolve([]),
  ])

  return {
    coverFile: coverFiles[0],
    bannerFile: bannerFiles[0],
  }
}
